import { z } from "zod/v4";

import { OnsiteInjectionDtoSchema } from "../../../../dtos/onsite-injections";

export const PluginOnsiteInjectionSchema_2024_05_05 = OnsiteInjectionDtoSchema;
export type PluginOnsiteInjectionType_2024_05_05 = z.infer<
  typeof PluginOnsiteInjectionSchema_2024_05_05
>;
